import { IconLayer } from 'deck.gl';
import { scaleLinear } from 'd3-scale';
import { colors } from '../../modules/theme';
const ICON_MAPPING = {
  marker: { x: 0, y: 0, width: 256, height: 256, mask: true },
};
const zoomScale = scaleLinear()
  .domain([3.8, 8, 14])
  .range([2, 7, 14]);
const getFrogIconLayer = ({
  data,
  hoveredFrog,
  setHoveredFrog,
  setActiveSubmissions,
  zoom,
  deckRef,
}) => {
  return new IconLayer({
    id: 'icon-layer',
    data,
    pickable: true,
    opacity: 1,
    sizeMinPixels: 2,
    iconAtlas: process.env.URL + '/circle.svg',
    iconMapping: ICON_MAPPING,
    getIcon: d => 'marker',
    sizeScale: 2,
    getPosition: d => [d.lng, d.lat],
    getSize: d => {
      const size = x => (hoveredFrog === d.id ? x * 1.4 : x);
      return size(zoomScale(zoom));
    },
    fp64: true,
    getColor: d => colors.limeDeckRGB,
    updateTriggers: {
      getSize: [zoom, hoveredFrog],
    },

    onHover: ({ object }) => {
      if (!object) {
        if (hoveredFrog) setHoveredFrog(null);
        return;
      }
      const newId = object.id;

      if (newId !== hoveredFrog) {
        return setHoveredFrog(newId);
      }
    },
  });
};
export default getFrogIconLayer;
